module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("试管百科 -" + _vm._s(_vm.headerName))]), _vm._v(" "), _c('ul', {
    staticClass: "TestTubeEncyclopediaList"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(index + 1) + "." + _vm._s(item.articleTitle))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508a1f00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/testTubeEncyclopedia/TestTubeEncyclopediaList.vue
// module id = JGOT
// module chunks = 7